import React, { useState, useEffect} from 'react';
import { Card, Form, Alert} from 'react-bootstrap';
import '../styles/Login.css';
import { HHIEButton } from './utility/HHIEButton';
import { HHIECard } from './utility/HHIECard';
import { HHIEError } from './utility/HHIEError';
import { HHIELinkBtn } from './utility/HHIELinkBtn';
import { returnPOCUserObject } from './utility/returnPOCUserObject';

function redirectToSalesforceLogin() {
    fetch('/api/login/GetSalesforceUrl')
        .then(response => {
            response.json()
                .then(text => {
                    if (text.errors !== null && text.errors !== "") alert(text.errors)
                    console.log(text.message);
                    window.location = text.message;
                })
                .catch(error => console.error("Inside Login text catch " + error));
        })
        .catch(error => console.error("Inside Login response catch " + error));
}

export function Login() {
    
    const [username, setUsername] = useState();
    const [password, setPassword] = useState();
    const [clicked, setClicked] = useState(false);
    const [errorMessage, setErrorMessage] = useState();
    const [show, setShow] = useState(false);
    const [success, setSuccess] = useState(false);
    const [successMsg, setSuccessMsg] = useState();
    const [registrationFeature, setRegistrationFeature] = useState(false);
    
    // ensure clicked gets reset to false after the login process has been created, to avoid weird errors.
    useEffect(() => {
        if (show || success) {
            setClicked(false);
        }
    }, [show, success])

    useEffect(() => {

        fetch('api/admin/GetFeatures')
            .then((response) => {
                response.json()
                    .then((json) => {
                        if (json.errors !== null && json.errors !== "") alert(json.errors);
                        for (var i = 0; i < json.message.length; i++) {
                            if (json.message[i].name === "registration") {
                                setRegistrationFeature(json.message[i].value);
                            }
                        }
                    })
                    .catch((error) => {
                        console.log("Retrieve json error: " + error);
                    })
            })
            .catch((error) => {
                console.log("Retrieve response error: " + error);
            })
    },[])

    const userExists = async (userId) => {
        var doesUserExist = false;
        doesUserExist = await fetch('api/POCUser/user-exists-with-userid/' + userId)
        .then((res) => res.json())
            .then((data) => {
                if (data.errors !== null && data.errors !== "") alert(data.errors);
                return data.message
            });
        return doesUserExist;
    };

    const userIsLockedOut = async (userId) => {
        var userIsLockedOut = true;
        userIsLockedOut = await fetch('api/POCUser/user-is-locked-out/' + userId)
        .then((res) => res.json())
            .then((data) => {
                if (data.errors !== null && data.errors !== "") alert(data.errors)
                return data.message
            });
        return userIsLockedOut;
    };

    const login = async () => {
        setClicked(true);
        const badCreds = "Invalid Credentials. Please try again, or contact the HHIE Staff.";
        const userExistsBool = await userExists(username);
        if (!userExistsBool) {
            setErrorMessage(badCreds);
            setShow(true);
            return;
        }
        const userIsLockedOutBool = await userIsLockedOut(username);
        if (userIsLockedOutBool) {
            setErrorMessage(username + " is locked out of this account because of too many failed login attempts. Please contact HHIE via email at helpdesk@hawaiihie.org or phone (808) 441-1374.");
            setShow(true);
            return;
        }
        const POCUserData = {
            username: username,
            password: password
        };
        const requestOptions = {
            method: "POST",
            body: JSON.stringify(POCUserData),
            headers: { "Content-type": "application/json: charset=UTF-8" }
        }
        
        // user can login, password is not temporary
        const user = await fetch('api/login/POC', requestOptions)
            .then(async (response) => {
                if (response.status === 204) {
                    return null;
                }
                try {
                    return await response.json()
                        .then(json => {
                            if (json.errors !== null && json.errors !== "") alert(json.alert);
                            return json.message;
                        });
                }
                catch (ex) {
                    console.log(ex);
                    return null;
                }
            })
            .catch((error) => {
                var message = "DEV ERROR: json conversion - [" + error + "]";
                console.log(message);
                setErrorMessage(message);
                setShow(true);
            });
        if (user !== null) {
            const pocUser = returnPOCUserObject(user);
            sessionStorage.setItem("user", JSON.stringify(pocUser));
            if (user.passwordIsTemporary) {
                sessionStorage.setItem("temporaryVerification", user.password);
            }
            var location = "/set-security-questions";
            var sucMessage = "You haven't completed your required registration, please wait while we redirect you. . .";
            if (pocUser.securityQuestionsComplete) {
                if (pocUser.passwordIsTemporary) {
                    location = "/reset-temp-password";
                } else {
                    location = "/registration-dashboard";
                    sucMessage = "Success! Please wait. . .";
                }
            }
            setSuccessMsg(sucMessage);
            setSuccess(true);
            setTimeout(() => { window.location.href = location; }, 2000);
            return;
        }
        else {
            setErrorMessage(badCreds);
            setShow(true);
        }
    };

    return (
        <HHIECard>
            <Card.Title>
                Login
            </Card.Title>
            <Form>
                <Form.Group className="mb-3" controlId="formBasicEmail">
                    <Form.Control
                        required
                        type="email"
                        placeholder="Enter username or email"
                        onChange={(e) => setUsername(e.target.value)}
                        disabled={!registrationFeature}
                    />
                </Form.Group>
                <Form.Group className="mb-3" controlId="formBasicPassword">
                        <Form.Control
                            required
                            type="password"
                            placeholder="Enter password"
                        onChange={(e) => setPassword(e.target.value)}
                        disabled={!registrationFeature}
                        />
                </Form.Group>
                {/* CLICKED, show loading alert */
                    !show && !success && clicked && <Alert variant="warning">Validating Credentials. . .</Alert>
                }
                {/* FAILED, show failed alert */
                show && !success &&
                <HHIEError message={errorMessage} onClick={() => {setShow(false)}}/>
                }
                {/* SUCCESS, show success alert */
                    success && 
                    <Alert variant="success">{successMsg}</Alert>
                }
                <Form.Group>
                    <HHIELinkBtn name="Forgot Password?"
                        onClick={() => { window.location.href = "/forgotPassword" }}
                        disabled={!registrationFeature}
                    />
                </Form.Group>
                <Form.Group>
                    <HHIEButton
                        id="log-in-btn"
                        title="Log In"
                        size="lg"
                        long="true"
                        disabled={!(username && password && registrationFeature)}
                        onClick={login} 
                    />
                </Form.Group>
                <Form.Group>
                    <HHIELinkBtn name="HHIE Staff" onClick={redirectToSalesforceLogin} />
                </Form.Group>
            </Form>
        </HHIECard>
    );
}
